import { Field, Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import { userValidation } from "../../utils/validation/userValidation";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import FormikDateOnlyInput from "../../components/common/inputs/FormikDateOnlyInput";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useEffect, useRef, useState } from "react";
import VendorTypeSelect from "../../components/common/inputs/VendorTypeSelect";
import { useAdminAccess } from "../../layout/access/AdminAccessContext";

export default function User() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);
  const { isAdmin } = useAdminAccess();

  const [vendorType, setVendorType] = useState([]);
  const [qrcode, setQrcode] = useState("");

  const formHandler = async (values, { resetForm }) => {
    const body = { ...values, vendoresAllowedToCreate: vendorType };
    try {
      if (!location?.state) {
        const response = await postApi({
          path: "admin/users",
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("کاربر با موفقیت اضافه شد");
        resetForm();
      } else {
        const response = await putApi({
          path: `admin/users/${location?.state.id}`,
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("اطلاعات کاربر با موفقیت آپدیت شد.");
      }
      navigate("/user-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const updateRole = async (role) => {
    const path = `admin/users/${location?.state?.id}/role`;
    const body = {
      role: role,
    };
    try {
      await putApi({ path, body });
      successMessage("نقش کاربر با موفقیت آپدیت شد.");
      navigate("/user-list");
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const [showVendorType, setShowVendorType] = useState(false);

  useEffect(() => {
    if (location?.state?.role == "vendoreOwner") {
      setShowVendorType(true);
    }
    if (location?.state?.vendoresAllowedToCreate?.length) {
      setVendorType(location?.state?.vendoresAllowedToCreate);
    }
  }, [location]);

  const vendorRef = useRef();

  const handleShowVendorType = (data) => {
    if (data === "vendoreOwner") {
      setShowVendorType(true);
      vendorRef?.current?.afterSubmit();
      setVendorType([]);
    } else {
      setShowVendorType(false);
      vendorRef?.current?.afterSubmit();
      setVendorType([]);
    }
  };
  const setGoogleSecret = async () => {
    const path = `admin/users/${location?.state?.id}/totpSecret`;
    try {
      const data = await putApi({ path });
      setQrcode(data.data?.result);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };
  return (
    <>
      <AdminFormLayout title={location?.state ? "ویرایش کاربر" : "افزودن کاربر"} description="اطلاعات کاربر، نقش و شرایط دسترسی او را در این صفحه مدیریت کنید.">

        <Formik
          enableReinitialize
          initialValues={
            location.state
              ? {
                  mobile: location?.state.mobile || "",
                  name: location?.state.name || "",
                  address: location?.state.address || "",
                  freeShipingEndDate: location?.state.freeShipingEndDate
                    ? location?.state.freeShipingEndDate.split("T")[0]
                    : "",
                  role: location?.state.role || "",
                  qrcode: location?.state.qrcode || "",
                }
              : {
                  mobile: "",
                  password: "",
                  name: "",
                  address: "",
                  role: isAdmin ? utils?.ROLES_VALUES?.[0]?.value || "admin" : "customer",
                }
          }
          validationSchema={userValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="mt-6">
                <FormSection title="اطلاعات حساب و دسترسی">
                  <div className="grid gap-6 mb-4 md:grid-cols-2">
                    <Input
                      disabled={location.state ? "disabeld" : ""}
                      name={"mobile"}
                      placeholder={"شماره"}
                      label="شماره"
                      type="text"
                    />
                    <Input
                      name={"name"}
                      placeholder={"نام"}
                      label={"نام"}
                      type="text"
                    />
                    <FormikDateOnlyInput name="freeShipingEndDate" label="پایان ارسال رایگان (تاریخ شمسی)" />
                    {!location.state && (
                      <Input
                        name={"password"}
                        placeholder={"رمز عبور"}
                        label={"رمز عبور"}
                        type={"password"}
                      />
                    )}
                    <div>
                      <Select
                        values={formik.values}
                        onChange={(e) => {
                          const role = e.target.value;
                          formik.setFieldValue("role", role);
                          handleShowVendorType(role);
                          console.log(role);
                        }}
                        name="role"
                        label="نقش"
                      >
                        {utils
                          ? utils?.ROLES_VALUES.filter(item => isAdmin || !["admin", "warehouseKeeper"].includes(item.value)).map((item) => {
                              return (
                                <option key={item.value} value={item.value}>{item.name}</option>
                              );
                            })
                          : null}
                      </Select>
                      {formik.errors.role && formik.touched.role ? (
                        <p className="text-sm my-4 text-red-900 dark:text-red-400">
                          {formik.errors.role}
                        </p>
                      ) : null}
                    </div>
                    {showVendorType ? (
                      <VendorTypeSelect
                        ref={vendorRef}
                        onChange={setVendorType}
                        oldVendor={location?.state?.vendoresAllowedToCreate || []}
                        label="انتخاب نوع غرفه"
                      />
                    ) : null}
                  </div>
                </FormSection>
                <div className="flex flex-col gap-y-2">
                  <Input
                    name={"address"}
                    placeholder={"آدرس"}
                    label={"آدرس"}
                    type={"textarea"}
                  />

                  <div className="admin-form-actions">
                    <Button disabled={formik.isSubmitting} loading={formik.isSubmitting} type="submit"
                      text={location?.state ? "ویرایش" : "افزودن"}
                      color={"success"}
                    />
                    {isAdmin && location?.state && (
                      <Button
                        onClick={() => updateRole(formik.values.role)}
                        type="button"
                        text={"آپدیت نقش"}
                        color={"success"}
                      />
                    )}
                    <button type="button" className="admin-form-cancel" onClick={() => navigate("/user-list")}>انصراف</button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      {isAdmin && location.state && ["admin", "warehouseKeeper"].includes(location.state?.role) ? (
        <FormSection title="ورود با برنامه رمزساز" description="کد QR ایجادشده را در برنامه رمزساز این حساب ثبت کنید.">
          <div className="grid gap-6 md:grid-cols-2 items-start">
            <div className="flex flex-wrap items-center gap-2">
              <Button
                text={"ایجاد کد رمزساز جدید"}
                type="button"
                onClick={setGoogleSecret}
                color={"success"}
              />
            </div>
            {qrcode ? (
              <div>
                <img className="w-full max-w-xs h-auto rounded-xl bg-white p-3" src={qrcode} alt="QR Code" />
              </div>
            ) : null}
          </div>
        </FormSection>
      ) : null}
      </AdminFormLayout>
    </>
  );
}
